
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const APP_STORE_URL = 'https://apps.apple.com/us/app/starlightsaga/id6757761088';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mysagallc.thisismysaga';

const getStoreUrl = () => {
  if (typeof navigator === 'undefined') return APP_STORE_URL;
  const ua = navigator.userAgent || '';
  if (/Android/i.test(ua)) return PLAY_STORE_URL;
  if (/iPad|iPhone|iPod/.test(ua)) return APP_STORE_URL;
  return APP_STORE_URL;
};

const SECTIONS = [
  { id: 'features', label: 'Features' },
  { id: 'about', label: 'About' },
  { id: 'contact', label: 'Contact' },
];

const Nav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [storeUrl] = useState(getStoreUrl);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') setIsOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen]);

  const goTo = (id) => (e) => {
    e.preventDefault();
    setIsOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className={`main-nav ${isOpen ? 'is-open' : ''}`}>
      <div className="nav-inner">
        <a href="/#home" className="nav-brand" onClick={goTo('home')}>
          <img src={`${process.env.PUBLIC_URL}/logo-icon.png`} alt="" className="nav-logo-icon" />
          <span>StarlightSaga</span>
        </a>

        <button
          type="button"
          className="nav-hamburger"
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isOpen}
          aria-controls="nav-menu"
          onClick={() => setIsOpen((v) => !v)}
        >
          <span className="nav-hamburger-bar" />
          <span className="nav-hamburger-bar" />
          <span className="nav-hamburger-bar" />
        </button>

        <div id="nav-menu" className="nav-menu">
          <ul className="nav-links">
            {SECTIONS.map(({ id, label }) => (
              <li key={id}>
                <a href={`/#${id}`} onClick={goTo(id)}>{label}</a>
              </li>
            ))}
          </ul>
          <a
            href={storeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-cta"
            onClick={() => setIsOpen(false)}
          >
            Download
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
